import { ProjectFilters } from '../../../models';

export const projectsInitialFilters: ProjectFilters = {
  status: undefined,
  creatorId: undefined,
  startDate: undefined,
  endDate: undefined,
  sortKey: undefined,
  sortDirection: undefined,
  projectType: undefined,
};
